/**
 * Shared constants across all platforms (Native, Web, etc.)
 */

/**
 * The identifier used for local data created when in Visitor Mode (unauthenticated).
 */
export const VISITOR_ID = "visitor";

/**
 * Standard HTTP Status Codes
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;

/**
 * The slug for the default "Inbox" list.
 */
export const INBOX_SLUG = "inbox";

/**
 * A stable reference for an empty array to prevent unnecessary re-renders in hooks.
 */
export const EMPTY_ARRAY: readonly never[] = Object.freeze([]);

/**
 * Deep Linking Configuration
 */
export const APP_SCHEME = "mealplan";
export const APP_DOMAIN = "app.mealplan.com";

/**
 * SOFT_DELETE_STANDARD — ventana de retención de la papelera (días). El job de
 * purga del servidor (`TRASH_PURGE_DAYS`, default 30) elimina definitivamente
 * las recetas soft-borradas cuyo `deleted_at` supera este umbral y registra
 * `purged` en `activity` con snapshot. El cliente lo usa SÓLO para el countdown
 * informativo «se eliminará en Y días» de la vista de papelera; la fuente de
 * verdad de la purga es el env del servidor (si allí se pone a 0 la purga se
 * desactiva, pero el default coincide con esta constante).
 */
export const TRASH_PURGE_DAYS = 30;
